import { useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Button,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { IOSSwitch } from '../IOSSwitch';

interface RouterBlockMaliciousEditProps {
  onSubmit: () => void;
  cpeId: string;
  isEnabled: boolean;
}

export const RouterBlockMaliciousEdit = ({ onSubmit, cpeId, isEnabled }: RouterBlockMaliciousEditProps) => {
  const api = useApi();
  const [newIsEnabled, setNewIsEnabled] = useState<boolean>(isEnabled);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewIsEnabled(e.target.checked);
    setDisableSubmit(e.target.checked === isEnabled);
  };

  const editDDos = useMutation(api.toggleCpeMaliciousIpBlockApiV1ToggleCpeMaliciousIpBlockPost, {
    onSuccess() {
      toast.success(`${newIsEnabled ? 'Enabled' : 'Disabled'} block malicious sources successfully.`);
      onSubmit();
    },
    onError: (error) => {
      apiError(error);
      setDisableSubmit(false);
    },
  });

  const handleSubmit = () => {
    setDisableSubmit(true);
    editDDos.mutate({
      cpe_id: cpeId,
      enabled: newIsEnabled || false
    });
  };

  return (
    <Box pt={2}>
      <Typography variant="body1" sx={{ mb: 6 }}>
        Enable or disable block malicious sources.
      </Typography>
      <Box display="flex" justifyContent="center" sx={{ mb: 4 }}>
        <FormControlLabel
          value="top"
          control={
            <IOSSwitch color="primary" checked={newIsEnabled} onChange={handleChange} />
          }
          label={newIsEnabled ? 'Enabled' : 'Disabled'}
          labelPlacement="bottom"
          sx={(theme) => ({ '&:hover': { color: theme.palette.primary.main } })}
          componentsProps={{
            typography: {
              sx: (theme) => ({
                fontSize: 12,
                color: !newIsEnabled ? theme.palette.grey[600] : theme.palette.primary.main,
              }),
            },
          }}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={disableSubmit}>
          Confirm
        </Button>
      </Box>
    </Box>
  );
};
